
/**
 * @file Signup actions
 * @author Denny K. Schuldt
 * @copyright Copyright 2017, Datilmedia S.A.
 */

import * as types from '../constants/action-types';


export function updateError(payload) {
  return {
    type: types.UPDATE_ERROR,
    payload
  }
}

export function changeUsername(payload) {
  return {
    type: types.CHANGE_USERNAME,
    payload
  }
}

export function changeEmail(payload) {
  return {
    type: types.CHANGE_EMAIL,
    payload
  }
}

export function changePassword(payload) {
  return {
    type: types.CHANGE_PASSWORD,
    payload
  }
}

export function changeSrc(payload) {
  return {
    type: types.CHANGE_SRC,
    payload
  }
}

export function changePromo(payload) {
  return {
    type: types.CHANGE_PROMO,
    payload
  }
}

export function changePlanFee(payload) {
  return {
    type: types.CHANGE_PLAN_FEE,
    payload
  }
}

export function changePlanCode(payload) {
  return {
    type: types.CHANGE_PLAN_CODE,
    payload
  }
}

export function validateUsername() {
  return {
    type: types.VALIDATE_USERNAME
  }
}

export function validateEmail() {
  return {
    type: types.VALIDATE_EMAIL
  }
}

export function validatePassword() {
  return {
    type: types.VALIDATE_PASSWORD
  }
}

export function validateForm() {
  return {
    type: types.VALIDATE_FORM
  }
}

function requestUsernameAvailableStarted() {
  return {
    type: types.REQUEST_USERNAME_AVAILABLE_STARTED
  }
}

function requestUsernameAvailableSucceed() {
  return {
    type: types.REQUEST_USERNAME_AVAILABLE_SUCCEED
  }
}

function requestUsernameAvailableFailed(status) {
  var payload = {}
  if(status == 400){
    return {
      type: types.REQUEST_USERNAME_IS_A_EMAIL_FAILED,
      payload
    }
  }else{
    return {
      type: types.REQUEST_USERNAME_AVAILABLE_FAILED,
      payload
    } 
  }
}

function requestEmailAvailableStarted() {
  return {
    type: types.REQUEST_EMAIL_AVAILABLE_STARTED
  }
}

function requestEmailAvailableSucceed() {
  return {
    type: types.REQUEST_EMAIL_AVAILABLE_SUCCEED
  }
}

function requestEmailAvailableFailed(payload) {
  return {
    type: types.REQUEST_EMAIL_AVAILABLE_FAILED,
    payload
  }
}

function requestFormSubmitStarted() {
  return {
    type: types.REQUEST_FORM_SUBMIT_STARTED
  }
}

export function submitForm(evt) {
  return (dispatch, getState) => {
    dispatch(validateForm())
      if (getState().get('valid')) {
          dispatch(requestFormSubmitStarted())
          $(evt.target).submit()
          gtag_report_conversion(undefined);
          fbq('track', 'SubmitApplication');
    } else {
      evt.preventDefault();
    }
  }
}

export function setReferralCode(payload){
  return {
    type : types.SET_REFERRAL_CODE,
    payload
  }
}


/************************************************/
/******************   ASYNC  ********************/
/************************************************/


export function usernameValidation(url) {
  return (dispatch, getState) => {
    dispatch(validateUsername())
    if (getState().getIn(['validations', 'localUsername']).length == 0) {
      dispatch(requestUsernameAvailableStarted())
      return $.ajax({
        method: 'GET',
        url,
        headers: {
          Accept: 'application/json; charset=utf-8'
        },
        dataType: 'json'
      })
      .done(data => dispatch(requestUsernameAvailableSucceed()))
      .fail(error => dispatch(requestUsernameAvailableFailed(error.status))
    )
    }
  }
}

export function emailValidation(url) {
  return (dispatch, getState) => {
    dispatch(validateEmail())
    if (getState().getIn(['validations', 'localEmail']).length == 0) {
      dispatch(requestEmailAvailableStarted())
      return $.ajax({
        method: 'GET',
        url,
        headers: {
          Accept: 'application/json; charset=utf-8'
        },
        dataType: 'json'
      })
      .done(data => dispatch(requestEmailAvailableSucceed()))
      .fail(err => dispatch(requestEmailAvailableFailed(JSON.parse(err.responseText))))
    }
  }
}
